const convertTimeHHMMSS = val => {
  let hhmmss = new Date(val * 1000).toISOString().substr(11, 8);
  return hhmmss.indexOf("00:") === 0 ? hhmmss.substr(3) : hhmmss;
};

export default {
  getMemory: state => {
    return state.memoryPads;
  },
  getUsedMemorySlots: state => {
    // Return the memory pads
    var n = {};
    Object.keys(state.memoryPads).forEach(key => {
      if (state.memoryPads[key].used) {
        n[key] = state.memoryPads[key];
      }
    });
    return n;
  },
  countVideos: state => memoryNr => {
    return state.memoryPads["memory" + memoryNr].content.length;
  },
  getMemoryActive: state => memoryNr => {
    return state.memoryPads["memory" + memoryNr].active;
  },
  memoryPads: state => {
    // Return the memory pads
    var n = [];
    Object.keys(state.memoryPads).forEach(key => {
      n.push(state.memoryPads[key].nr);
    });
    return n;
  },
  notes: state => {
    // Return all the notes for pad layout
    const notes = state.volatile.pads.map(pad => pad.note);
    return notes;
  },
  cuePoint: state => currentNote => {
    // Return cue point for a given note
    var n = 0; // temporary variable
    state.volatile.pads.forEach(pad => {
      if (pad.note == currentNote) {
        n = pad.cuePoint; // Return cue point
      }
    });
    return n; // return value
  },
  prettyCuePoint: state => currentNote => {
    // Formatting seconds to ISO for display only
    const number = state.volatile.pads.find(pad => pad.note === currentNote)
      .cuePoint;
    return convertTimeHHMMSS(number);
  },
  accurateCuePoint: state => currentNote => {
    const number = state.volatile.pads.find(pad => pad.note === currentNote)
      .cuePoint;
    return Math.round(number * 100) / 100 + " s"; // return rounded time signature in seconds
  }
};
